// get_ai_prompts
export const GET_AI_PROMPT = 'get_ai_prompts';
export const GET_AI_PROMPT_SUCCESSFUL = 'get_ai_prompts_successfull';
export const GET_AI_PROMPT_FAILED = 'get_ai_prompts_failed';

// create_ai_prompt
export const CREATE_AI_PROMPT = 'create_ai_prompt';
export const CREATE_AI_PROMPT_SUCCESSFUL = 'create_ai_prompt_successfull';
export const CREATE_AI_PROMPT_FAILED = 'create_ai_prompt_failed';

// update_ai_prompt
export const UPDATE_AI_PROMPT = 'update_ai_prompt';
export const UPDATE_AI_PROMPT_SUCCESSFUL = 'update_ai_prompt_successfull';
export const UPDATE_AI_PROMPT_FAILED = 'update_ai_prompt_failed';

// delete_ai_prompt
export const DELETE_AI_PROMPT = 'delete_ai_prompt';
export const DELETE_AI_PROMPT_SUCCESSFUL = 'delete_ai_prompt_successfull';
export const DELETE_AI_PROMPT_FAILED = 'delete_ai_prompt_failed';
